import { render, staticRenderFns } from "./ButtonContent.vue?vue&type=template&id=5dd35591&scoped=true"
import script from "./ButtonContent.vue?vue&type=script&lang=js"
export * from "./ButtonContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd35591",
  null
  
)

export default component.exports